<!-- <wncm-form-control-text
    class="inlineInput"
    [control]="searchControl"
    placeholder="Rechercher"
    iconName="search"
></wncm-form-control-text> -->
<form class="search-product">
    <mat-form-field class="inline-search-bar" appearance="outline">

        <input matInput type="text" name="search"
            placeholder="Rechercher"
            [(ngModel)]="searchControl.value"
            (ngModelChange)="changeSearchValue($event)"
        />
        <mat-icon matSuffix>search</mat-icon>

        <mat-icon matSuffix
            *ngIf="searchControl != null && searchControl != ''"
            style="margin-left: 20px; cursor: pointer"
            (click)="searchControl.setValue(''); this.saveFrom = null;">
            close
        </mat-icon>
    </mat-form-field>
</form>
<div [ngClass]="inline ? 'inline' : ''" class="optionContainer">
    <ng-container *ngIf="saveFrom == null">
        <div *ngFor="let org of from">
            <!-- Add Checkbox to select every screens in organization  -->
            <mat-checkbox
                [value]="org.id"
                (change)="selectOrganization(org.id, $event)"
                class="checkbox"
            >
                <span class="organizationItem">
                    <mat-icon>place</mat-icon>
                    {{org.o}}
                </span>
            </mat-checkbox>
    
            <!-- <div class="shelfSite" *ngFor="let loc of org.f"> -->
                <!-- <span class="shelfItem">{{loc.sc}}</span> -->
                <div class="screenSite">
                    <span class="screenItem"  *ngFor="let item of org.f">
                        <label>
                            <mat-checkbox
                                *ngIf="canSelect"
                                [disabled]="disabled"
                                [value]="item.id"
                                (change)="checkChanged($event)"
                                [checked]="position(item[value]) > -1"
                                class="checkbox"
                            >
                            {{item.sc}}
                            </mat-checkbox>
                        </label>
                    </span>
                </div>
            <!-- </div> -->
        </div>
    </ng-container>
	<ng-container *ngIf="saveFrom != null">
        <div *ngFor="let org of saveFrom">
            <!-- Add Checkbox to select every screens in organization  -->
            <mat-checkbox
                [value]="org.id"
                (change)="selectOrganization(org.id, $event)"
                class="checkbox"
            >
                <span class="organizationItem">
                    <mat-icon>place</mat-icon>
                    {{org.o}}
                </span>
            </mat-checkbox>
    
            <div class="shelfSite" *ngFor="let face of org.f">
                <!-- <span class="shelfItem">{{face.n}}</span> -->
                <div class="screenSite">
                               
                    <span class="screenItem" >
                        <label>
                            <mat-checkbox
                                *ngIf="canSelect"
                                [disabled]="disabled"
                                [value]="face.id"
                                (change)="checkChanged($event)"
                                [checked]="position(face[value]) > -1"
                                class="checkbox"
                            >
                            {{face.sc}}
                            </mat-checkbox>
                        </label>
                    </span>
                </div>
            </div>
        </div>
        <p class="noResult" *ngIf="resultComment == true">Pas de résultat correspondant</p>
    </ng-container>
</div>
